"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionListArguments = exports.PermissionListOptions = void 0;
exports.PermissionListOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        default: "./appPackage/manifest.json",
    },
    {
        name: "env",
        type: "string",
        description: "Specifies the environment name for the project.",
    },
    {
        name: "entra-app-manifest-file",
        questionName: "manifest-file-path",
        type: "string",
        shortName: "a",
        description: "Specifies the Microsoft Entra app manifest file path, can be either absolute path or relative path to project root folder.",
        default: "./aad.manifest.json",
    },
];
exports.PermissionListArguments = [];
//# sourceMappingURL=PermissionListOptions.js.map